export default "__VITE_ASSET__BFDX3GuT__"